import script from "./NewDataShow.vue?vue&type=script&setup=true&lang=js"
export * from "./NewDataShow.vue?vue&type=script&setup=true&lang=js"

import "./NewDataShow.vue?vue&type=style&index=0&id=5fd0bfde&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd0bfde"]])

export default __exports__